<template>
    <div>
        <v-overlay :value="loadingWorkOrderGroupData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-card height="100vh">
            <v-toolbar dense color="bal-gray">
                <v-card-title
                    >{{
                        $route.params.workOrderId
                            ? activeWorkOrder.production_order_number
                            : activeWorkOrderGroup.production_order_number
                    }}
                </v-card-title>
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    color="bal-red"
                    @click="editWorkOrderGroup"
                    v-if="tabName === 'Group info' && user && user.role === PermissionsConstants.ROLE_SUPERADMIN"
                >
                    <v-icon>edit</v-icon>
                    {{ t("Edit") }}
                </v-btn>
                <v-btn
                    dark
                    color="bal-red"
                    @click="handleNewWorkOrderClick"
                    v-if="tabName === 'Work orders' && user && user.role === PermissionsConstants.ROLE_SUPERADMIN"
                >
                    <v-icon>add</v-icon>
                    {{ t("New work order") }}
                </v-btn>
                <v-menu
                    offset-y
                    bottom
                    left
                    v-if="tabName !== 'General info' && user && user.role === PermissionsConstants.ROLE_SUPERADMIN"
                >
                    <template v-slot:activator="{ on }">
                        <v-btn color="bal-dark-gray" class="px-2 ml-2 mx-2" style="min-width: 0;" dark v-on="on">
                            <v-icon>expand_more</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="handleDeleteClick">
                            <v-list-item-title style="color: red">{{ t("Delete") }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn icon @click="handleCloseClick">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
                <v-tab style="text-transform: none !important;" v-if="$route.params.workOrderId">
                    {{ t("General info") }}
                </v-tab>
                <v-tab-item v-if="$route.params.workOrderId">
                    <general-info-tab />
                </v-tab-item>
                <v-tab style="text-transform: none !important;">
                    {{ t("Group info") }}
                </v-tab>
                <v-tab-item>
                    <group-info-tab />
                </v-tab-item>
                <v-tab style="text-transform: none !important;">
                    {{ t("Work orders") }}
                </v-tab>
                <v-tab-item>
                    <group-work-orders-list-tab :stayToWorkOrder="stayToWorkOrder"/>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Store from "@/store";
import GeneralInfoTab from "@/pages/work-order/work-order-group-tab-items/general-info-tab";
import GroupInfoTab from "@/pages/work-order/work-order-group-tab-items/group-info-tab";
import GroupWorkOrdersListTab from "@/pages/work-order/work-order-group-tab-items/group-work-orders-list-tab";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "work-order-group-view",
    components: { GroupWorkOrdersListTab, GeneralInfoTab, GroupInfoTab },
    props: {
        stayToWorkOrder: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            tab: 0,
            tabs: ["General info", "Group info", "Work orders"]
        };
    },
    async mounted() {
        if(this.$route?.query?.tab && this.tabs.includes(this.$route?.query?.tab)) {
            this.tab = this.tabs.indexOf(this.$route.query.tab);
        }

        let workOrderGroupID = this.$route.params.workOrderGroupId;
        if (workOrderGroupID && (!this.activeWorkOrderGroup.id || this.activeWorkOrderGroup.id !== workOrderGroupID) && workOrderGroupID !== "new") {
            await this.fetchWorkOrderGroupData(workOrderGroupID);
        }

        let workOrderId = this.$route.params.workOrderId ?? null;
        if (workOrderId) {
            if (this.activeWorkOrder && this.activeWorkOrder.id !== workOrderId) {
                await this.getWorkOrder(workOrderId);
            }
        }
    },
    computed: {
        ...mapState("WorkOrderStore", [
            "activeWorkOrderGroup",
            "loadingWorkOrderGroupData",
            "activeWorkOrderGroup",
            "activeWorkOrder"
        ]),
        ...mapState(["user"]),
        tabName() {
            return this.tabs[this.tab];
        },
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    methods: {
        ...mapMutations("WorkOrderStore", ["toggleWorkOrderGroupDrawer"]),
        ...mapActions("WorkOrderStore", [
            "fetchWorkOrderGroupData",
            "createNewWorkOrder",
            "getWorkOrder",
            "deleteWorkOrderGroup",
            "fetchWorkOrders"
        ]),
        handleCloseClick() {
            this.toggleWorkOrderGroupDrawer(false);

            if (this.stayToWorkOrder) {
                this.$router.push({ name: "work-order-view", params: {workOrderId: this.$route.params.workOrderId} });
            } else {
                this.$router.push({ name: "work-order-list" });
            }
        },
        editWorkOrderGroup() {
            let workOrderId = this.$route.params.workOrderId ?? null;
            this.$router.push({
                name: "work-order-group-edit",
                params: { workOrderGroupID: this.$route.params.workOrderGroupID, workOrderId }
            });
        },
        handleDeleteClick() {
            if (
                confirm(
                    this.t(
                        "Are you sure you want to delete this work order group? This will delete entire group not only work order."
                    )
                )
            ) {
                this.deleteWorkOrderGroup(this.activeWorkOrderGroup.id);
                this.fetchWorkOrders({});
                this.$router.push({
                    name: "work-order-list"
                });
            }
        },
        async handleNewWorkOrderClick() {
            let newWorkOrderID = await this.createNewWorkOrder(this.activeWorkOrderGroup.id);
            await this.getWorkOrder(newWorkOrderID);
            await this.$router.push({ name: "work-order-view", params: { workOrderId: newWorkOrderID } });
        }
    }
};
</script>
